import useGetApplicationRole from './useGetApplicationRole'

export default useGetApplicationRole
